import React from 'react'

import Head from '../head'
import { Title } from '@cms/ui'
import { cleanUrl } from '@cms/utils'

const NewsPage = ({ data: { title, desc, items } }) => {
  return (
    <div className="row">
      <Head title={title} desc={desc} />
      <div className="column">
        <Title>{title}</Title>
        {items.map((item) => (
          <p key={item.id}>
            <a href={item.link} target="_blank" rel="noreferrer">
              {item.label}
            </a>
          </p>
        ))}
      </div>
    </div>
  )
}

export async function getStaticProps({ preview = false }) {
  const { fetchSingluarType } = await import('../data')
  const data = await fetchSingluarType('news-page', ['scrapbooking.asset'])

  const items = data.scrapbooking.map(({ id, label, link, asset }) => ({
    id,
    label,
    link: asset?.data?.attributes?.url
      ? cleanUrl(
          `${process.env.NEXT_STRAPI_PUBLIC_ENDPOINT}/${asset?.data?.attributes?.url}`
        )
      : link,
  }))

  delete data.scrapbooking

  return {
    props: {
      preview,
      data: {
        title: data.title,
        desc: data.description,
        items,
      },
    },
  }
}

export default NewsPage
